import { Play } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface TourTriggerProps {
  onStartTour: () => void;
  label?: string;
  variant?: 'outline' | 'default' | 'secondary' | 'ghost' | 'link';
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}

export const TourTrigger = ({ onStartTour }: TourTriggerProps) => {
  return (
    <Button onClick={onStartTour} className={`gap-2 bg-brand-300 text-white`}>
      <Play className="h-4 w-4" />
      Tour
    </Button>
  );
};
